import space from '@styled-system/space'
import typography from '@styled-system/typography'
import { em } from 'polished'
import styled from 'styled-components'

import FirstBlockWrapper from 'components/_special/FirstBlockWrapper'
import DynamicImage from 'components/DynamicImage'
import List from 'components/List'
import CostContainerSale from 'containers/CostContainerSale'
import { Col, Row } from 'styles/components/layout'

export const ListStyled = styled(List)`
  // padding-left: ${em(5)};
  text-align: left;
  margin-left: 0;

  & mark {
    background: transparent;
    color: ${p => p.theme.colors[p.markColor || 'grass']};
  }
`

export const ListWrapper = styled.div`
  display: inline-block;
  max-width: ${em(450)};
  width: 100%;

  ${p => p.theme.mq.upLg} {
    max-width: ${em(573)};
  }
`

export const SalesContainer = styled.div`
  max-width: ${em(450)};
  margin: 0 auto;

  ${p => p.theme.mq.upMd} {
    margin: 0;
  }
`

export const FirstBlockWrapperStyled = styled(FirstBlockWrapper)`
  background: ${p => p.theme.colors[p.bg || 'lilac']};
  padding-bottom: ${p => em(p.isExtraBottomIndent ? 40 : 20)};
  color: ${p => p.theme.colors.white};

  ${p => p.theme.mq.upMd} {
    padding-bottom: ${em(40)};
  }
`

export const RowStyled = styled(Row)`
  padding-top: ${em(20)};

  ${p => p.theme.mq.upMd} {
    padding-top: ${em(40)};
  }
`

export const ColStyled = styled(Col)`
  ${space};
  ${typography};
  position: relative;
`

export const CostWrapper = styled.div`
  display: flex;
  justify-content: ${p => (p.isMobileLeftAlign ? 'flex-start' : 'center')};
  align-items: center;

  ${p => p.theme.mq.upMd} {
    justify-content: start;
  }
`

export const CostContainerSaleStyled = styled(CostContainerSale)`
  margin-right: ${em(30)};
`

export const LabelsWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: ${em(30)};

  ${p => p.theme.mq.upMd} {
    margin-bottom: ${em(40)};
  }
`

export const DiscountLabel = styled.div`
  background: ${p => p.theme.colors[p.bg || 'yellow']};
  color: ${p => p.theme.colors[p.textColor || 'black']};
  font-family: ${p => p.theme.typography.mediumFont};
  padding: ${em(4)} ${em(5)} ${em(7)};
  border-radius: ${em(4)};

  ${p => p.theme.mq.upMd} {
    padding: ${em(5)} ${em(5)} ${em(7)};
  }
`

export const BlackFridayLabel = styled.div`
  background: ${p => p.theme.colors.lighterGrayOp3};
  padding: ${em(4)} ${em(11)} ${em(7)};
  border-radius: ${em(4)};
  margin-left: ${em(10)};

  ${p => p.theme.mq.upMd} {
    padding: ${em(5)} ${em(11)} ${em(7)};
  }
`

export const LabelText = styled.div`
  font-size: ${p => p.theme.typography.textDisclaimer};
  font-weight: 400;
  line-height: 1;

  ${p => p.theme.mq.upMd} {
    font-size: ${p => p.theme.typography.textDisclaimerMd};
  }
`

export const ButtonInner = styled.span`
  display: inline-block;
  // font-family: ${p => p.theme.typography.mediumFont};
  font-weight: 400;
  font-size: 1em;
  line-height: 2;
  padding: ${em(2)} ${em(25)} ${em(6)};

  ${p => p.theme.mq.upMd} {
    font-size: 1em;
    line-height: 1.77;
  }
`

export const Decorations = styled.div`
  position: absolute;
  top: -${em(10)};
  right: 0;
  left: 0;
  margin: 0 auto;
  width: 87%;
  max-width: ${em(325)};

  ${p => p.theme.mq.upMd} {
    top: -${em(0)};
    right: 10%;
    left: initial;
    margin: 0;
    width: ${em(287)};
    max-width: none;
  }

  ${p => p.theme.mq.upLg} {
    right: -8%;
    top: -10%;
    width: 80%;
  }

  ${p => p.theme.mq.upXl} {
    top: -${em(40)};
    right: -${em(50)};
    max-width: ${em(470)};
  }
`

export const DynamicImageStyled = styled(DynamicImage)`
  ${p => p.theme.mq.upMd} {
    height: inherit;
    object-position: left top;
  }
`
